// extracted by mini-css-extract-plugin
module.exports = {"title":"SideModuleWrapper_title__OHTGb"};